import { Link } from 'react-router-dom';
import membershipApplication from './2026 Membership Application.docx';
import './membership-document.scss';

const MembershipDocument = () => (
    <main className="membership-document-page">
        <section className="membership-document-hero">
            <p className="membership-document-eyebrow">Missouri Self-Insurers Association</p>
            <h1>Membership Application</h1>
        </section>

        <section className="membership-document-content" aria-label="Application instructions">
            <div className="membership-document-inner">
                <div className="membership-document-download">
                    <div>
                        <h2>Start your membership application download</h2>
                    </div>
                    <a
                        className="membership-document-download-button"
                        href={membershipApplication}
                        download="MSIA-2026-Membership-Application.docx"
                    >
                        Download application
                    </a>
                </div>

                <ol className="membership-document-steps">
                    <li>
                        <span className="membership-document-step-number">1</span>
                        <div>
                            <h3>Download the application</h3>
                        </div>
                    </li>
                    <li>
                        <span className="membership-document-step-number">2</span>
                        <div>
                            <h3>Fill out the application</h3>
                        </div>
                    </li>
                    <li>
                        <span className="membership-document-step-number">3</span>
                        <div>
                            <h3>Email the completed application to{' '}
                                <a href="mailto:info@msia-mo.org?subject=Completed%20MSIA%20Membership%20Application">
                                    info@msia-mo.org
                                </a></h3>
                        </div>
                    </li>
                </ol>

                <p className="membership-document-followup">
                    Once we receive your completed application, our team will contact you as soon as possible
                </p>
                <Link className="membership-document-home-link" to="/">Return to home</Link>
            </div>
        </section>
    </main>
);

export default MembershipDocument;